// extracted by css-extract-rspack-plugin
export default {"fullPageOnboarding":"src-shared-components-MainLayout-components-FullPageOnboarding-FullPageOnboarding-module__fullPageOnboarding-vmsq8N","pageViewport":"src-shared-components-MainLayout-components-FullPageOnboarding-FullPageOnboarding-module__pageViewport-D2pXQ6","page":"src-shared-components-MainLayout-components-FullPageOnboarding-FullPageOnboarding-module__page-UYWJf2","roleOverviewPage":"src-shared-components-MainLayout-components-FullPageOnboarding-FullPageOnboarding-module__roleOverviewPage-R4T83i"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"fullPageOnboarding\":\"src-shared-components-MainLayout-components-FullPageOnboarding-FullPageOnboarding-module__fullPageOnboarding-vmsq8N\",\"pageViewport\":\"src-shared-components-MainLayout-components-FullPageOnboarding-FullPageOnboarding-module__pageViewport-D2pXQ6\",\"page\":\"src-shared-components-MainLayout-components-FullPageOnboarding-FullPageOnboarding-module__page-UYWJf2\",\"roleOverviewPage\":\"src-shared-components-MainLayout-components-FullPageOnboarding-FullPageOnboarding-module__roleOverviewPage-R4T83i\"}";
        // 1793874319194
        var cssReload = require("../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  